exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.close-modal-button-container i[data-v-931bde16] {\n    cursor: pointer;\n    font-size: 1.5em;\n}\n.v--modal-box[data-v-931bde16] {\n    z-index: 1050;\n}\n", ""]);

// exports
